import React from 'react'
import {motion} from 'framer-motion'
import {AppWrap, MotionWrap} from '../../wrapper'
import { images } from '../../constants'
import './About.scss'

const About = () => {
  const values = [
    {
      id: 1,
      title: 'Excellence',
      description: 'We deliver solutions that set new standards.',
      icon: '🏆'
    },
    {
      id: 2,
      title: 'Integrity',
      description: 'We stay true to our word and principles.',
      icon: '🤝'
    },
    {
      id: 3,
      title: 'Innovation',
      description: 'We constantly reimagine better ways to create and solve.',
      icon: '💡'
    },
    {
      id: 4,
      title: 'Collaboration',
      description: 'We believe the best outcomes come from teamwork.',
      icon: '🤝'
    },
    {
      id: 5,
      title: 'Impact',
      description: 'We focus on results that improve lives and businesses.',
      icon: '🎯'
    }
  ]

  return (
    <div className='app__about-wrapper-upper'>
      <h2 className='head-text'>
        About <span>Scoolj Institute</span>
      </h2>
      
      {/* Our Story Section */}
      <div className='app__about-wrapper'>
      <div className='app__about-story'>
        <motion.div
          whileInView={{opacity: [0, 1], y: [50, 0]}}
          transition={{duration: 0.7}}
          className='app__about-story-content'
        >
          <h3 className='head-text-small'>Our Story</h3>
          <p className='p-text'>
            Scoolj Institute is a multidisciplinary Edutech, business advisory, and technology innovation 
            company dedicated to transforming how people learn, how businesses grow, and how digital experiences are built. 
            We exist at the intersection of education, technology, and strategy, empowering individuals and organizations 
            to thrive in a rapidly evolving digital world.
          </p>
          <p className='p-text'>
            Founded on the belief that Africa's growth will be shaped by skilled people and innovative organizations, 
            Scoolj Institute was created to bridge the gap between learning, technology, and business development.
          </p>
          <div className='app__about-purpose'>
            <span className='bold-text'>Every project we take on reflects our core purpose: to equip, empower, and elevate.</span>
          </div>
        </motion.div>
      </div>

      {/* Mission & Vision Section */}
      <div className='app__about-mission-vision'>
        <motion.div
          whileInView={{opacity: [0, 1], x: [-100, 0]}}
          transition={{duration: 0.6}}
          className='app__about-mission'
        >
          <div className='app__about-mv-icon'>
            <span>🎯</span>
          </div>
          <h3 className='head-text-small'>Our Mission</h3>
          <p className='p-text'>
            To empower individuals and businesses with the knowledge, technology, and strategic support 
            they need to create long-lasting impact.
          </p>
        </motion.div>

        <motion.div
          whileInView={{opacity: [0, 1], x: [100, 0]}}
          transition={{duration: 0.6, delay: 0.2}}
          className='app__about-vision'
        >
          <div className='app__about-mv-icon'>
            <span>🚀</span>
          </div>
          <h3 className='head-text-small'>Our Vision</h3>
          <p className='p-text'>
            To become Africa's leading hub for digital innovation, capacity development, 
            and business transformation.
          </p>
        </motion.div>
      </div>

      {/* Core Values Section */}
      <div className='app__about-values'>
        <motion.h3 
          whileInView={{opacity: [0, 1]}}
          transition={{duration: 0.5}}
          className='head-text-small'
        >
          Our Core Values
        </motion.h3>
        
        <div className='app__about-values-container'>
          {values.map((value, index) => (
            <motion.div
              whileInView={{opacity: [0, 1], y: [50, 0]}}
              transition={{duration: 0.5, delay: index * 0.1}}
              className='app__about-value-item'
              key={value.id}
            >
              <div className='app__about-value-icon'>
                <span>{value.icon}</span>
              </div>
              <h4 className='bold-text'>{value.title}</h4>
              <p className='p-text'>{value.description}</p>
            </motion.div>
          ))}
        </div>
      </div>


      {/* Scoolj Lab Subsidiary Section */}
      <motion.div
        whileInView={{opacity: [0, 1], y: [50, 0]}}
        transition={{duration: 0.7, delay: 0.3}}
        className='app__about-subsidiary'
      >
        <div className='app__about-subsidiary-content'>
          <h3 className='head-text-small'>
            Our Subsidiary – <span>Scoolj Lab</span>
          </h3>
          <p className='p-text'>
            Scoolj Lab is our dedicated technology unit focused on designing and building digital products 
            with strong functionality, clean UX, and long-term scalability. We work with entrepreneurs, 
            startups, and institutions to bring ideas to life.
          </p>
          <button className='app__about-cta-btn'>
            <span>Explore Scoolj Lab</span>
          </button>
        </div>
        <div className='app__about-subsidiary-image'>
          <img src={images.scooljdot} alt="Scoolj Lab" />
        </div>
      </motion.div>
      </div>
    </div>
  )
}

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg'
)